import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Modal from "antd/lib/modal/Modal";
import { ScopeContext } from "components/Assessment/contexts/ScopeContext";
import { useCallback, useContext } from "react";

import { GraphTooltip } from "../../GraphTooltip";
import { GraphSearchProps } from "../GraphSearch";
import { TermBuilderForm } from "./form";

/** An interactive term builder for building assessment queries */
export const InteractiveTermBuilder: React.FC<{
  controls: GraphSearchProps["controls"];
  onAddTerm: (term: string) => void;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}> = ({ controls, onAddTerm, isOpen, onOpen, onClose }) => {
  const { provider } = useContext(ScopeContext);

  const handleSubmit = useCallback(
    (term: string) => {
      onClose();
      onAddTerm(term);
    },
    [onClose, onAddTerm]
  );

  return (
    <>
      <GraphTooltip title="Interactively add a search term">
        <Button
          icon={<PlusOutlined />}
          onClick={onOpen}
          style={{
            marginLeft: "-1px",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
        />
      </GraphTooltip>
      <Modal
        footer={null}
        maskClosable={false}
        onCancel={onClose}
        open={isOpen}
        width="600px"
      >
        <TermBuilderForm
          controls={controls}
          provider={provider}
          onSubmit={handleSubmit}
        />
      </Modal>
    </>
  );
};
